import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Divider, Grid, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DropDown from "../../../Components/DropDown/DropDown";
import MuiInputField from "../../../Components/InputField/InputField";
import AddButton from "../../../Components/AddButton/AddButton";
import { isEmpty } from "../../../Utils/helper";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

function AlertPopUp(props) {
  return (
    <Box
      sx={{
        ...style,
        width: 400,
        border: "1px solid lightgray",
        height: 200,
        borderRadius: "15px",
        outline: "none",
        padding: 0,
      }}
    >
      <Grid container justifyContent="flex-end" alignItems={"center"}>
        <Box
          onClick={() =>
            props.setOpenModal({
              isOpen: false,
            })
          }
          sx={{
            width: 20,
            height: 20,
            backgroundColor: "#adbdd6",
            borderRadius: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "10px",
            marginTop: "10px",
            cursor: "pointer",
          }}
        >
          <CloseIcon
            sx={{
              width: 15,
              color: "white",
            }}
          />
        </Box>
      </Grid>
      <Grid>
        <Typography sx={{ textAlign: "center", fontWeight: "bold" }}>
          {props?.headText}
        </Typography>
      </Grid>
      <Grid
        container
        item
        lg={11.5}
        height={"90px"}
        justifyContent="center"
        alignItems={"center"}
        sx={{ gap: "5px" }}
      >
        {props?.data.buttons.map((item) => {
          return (
            <Button>
              <Box
                onClick={() => {
                  if (item.buttonName === "No") {
                    props?.setOpenModal({ isOpen: false });
                  } else if (item.buttonName == "Yes") {
                    props.handleYes();
                  }
                }}
                sx={{
                  padding: "10px 30px",
                  borderRadius: "6px",
                  border: item.buttonName === "No" ? "1px solid black" : "none",
                  backgroundColor:
                    item.buttonName === "No"
                      ? "#fff"
                      : props.warning
                      ? "red"
                      : "#17dfba",
                  textTransform: "capitalize",
                }}
              >
                <Typography
                  sx={{
                    color: item.buttonName === "No" ? "#000" : "white",
                  }}
                >
                  {item.buttonName}
                </Typography>
              </Box>
            </Button>
          );
        })}
      </Grid>
    </Box>
  );
}

export default function CityMadalPopUp({ setOpenModal, openModal, data }) {
  const handleOpen = () => {
    setOpenModal({ isOpen: true });
  };
  const handleClose = () => {
    setOpenModal({ isOpen: false });
  };

  const [stateList, setStateList] = React.useState([]);

  const [cityData, setCityData] = React.useState({});

  React.useEffect(() => {
    setCityData({
      countryId: { id: data?.data?.countryId, name: data?.data?.cellItem3 },
      name: data?.data?.cellItem1,
      platformIds: [1, 2, 3],
      stateId: { id: data?.data?.stateId, name: data?.data?.cellItem2 },
    });
  }, [data]);

  return (
    <div style={{ display: "none" }}>
      <Button onClick={handleOpen}>Open modal</Button>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        {data?.data?.headText.includes("Location") ? (
          <Box
            sx={{
              ...style,
              width: data?.data?.width ? data?.data?.width : 650,
              border: "1px solid lightgray",
              height: data?.data?.height ? data?.data?.height : 330,
              borderRadius: "15px",
              outline: "none",
              padding: 0,
            }}
          >
            <Grid
              container
              justifyContent="space-between"
              alignItems={"center"}
            >
              <Typography sx={{ fontWeight: 600, padding: "12px 20px" }}>
                {data?.data?.headText || ""}
              </Typography>

              <Box
                onClick={() => setOpenModal({ isOpen: false })}
                sx={{
                  width: 20,
                  height: 20,
                  backgroundColor: "#adbdd6",
                  borderRadius: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
              >
                <CloseIcon sx={{ width: 15, color: "white" }} />
              </Box>
            </Grid>
            <Divider />
            {data?.data?.headText.includes("Location") && (
              <>
                <Grid
                  lg={12}
                  container
                  justifyContent={"center"}
                  height={"130px"}
                  alignItems={"center"}
                >
                  <Grid
                    lg={11.2}
                    container
                    height={"100px"}
                    sx={{ border: "1px solid #adbdd6", borderRadius: "10px" }}
                    justifyContent={"space-around"}
                    alignItems={"flex-start"}
                  >
                    <Grid lg={3.5} marginTop={"5px"}>
                      <Typography fontSize={"14px"} paddingY={"5px"}>
                        Select Country
                      </Typography>
                      <DropDown
                        placeHolder="Select Country"
                        viewHeight={"45px"}
                        viewWidth={"100%"}
                        borderRadius={"7px"}
                        bgColor="white"
                        value={cityData?.countryId}
                        border={"1px solid #adbdd6"}
                        handleSelected={(e, value) => {
                          setCityData((s) => ({
                            ...s,
                            countryId: value,
                          }));
                          data?.data?.handleSelected(value?.id).then((res) => {
                            if (res) {
                              setStateList(res);
                            }
                          });
                        }}
                        data={data?.data?.countryList}
                      />
                    </Grid>
                    <Grid lg={3.5} marginTop={"5px"}>
                      <Typography fontSize={"14px"} paddingY={"5px"}>
                        Select State
                      </Typography>
                      <DropDown
                        placeHolder="Select State"
                        viewHeight={"45px"}
                        borderRadius={"7px"}
                        value={cityData?.stateId}
                        bgColor="white"
                        viewWidth={"100%"}
                        border={"1px solid #adbdd6"}
                        data={stateList}
                        handleSelected={(e, value) => {
                          setCityData((s) => ({
                            ...s,
                            stateId: value,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid lg={3.5} marginTop={"5px"}>
                      <Typography fontSize={"14px"} paddingY={"5px"}>
                        Add City
                      </Typography>
                      <MuiInputField
                        value={cityData?.name}
                        onChange={(event) => {
                          setCityData((s) => ({
                            ...s,
                            name: event.target.value,
                          }));
                        }}
                        placeHolder={"Enter City"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  container
                  justifyContent={"center"}
                  marginBottom={"20px"}
                >
                  {/* hiding addnew for first version */}
                  {/* <Grid item lg={11.2}>
                      <Grid item lg={2.4}>
                        <AddButton
                          labelName={"Add New"}
                          viewHeight={"45px"}
                          borderRadius={"5px"}
                        />
                      </Grid>
                    </Grid> */}
                </Grid>
              </>
            )}
            <Divider />
            <Grid
              container
              item
              lg={11.5}
              height={"90px"}
              justifyContent="flex-end"
              alignItems={"center"}
              sx={{ gap: "5px" }}
            >
              {data &&
                data?.data?.buttons.map((item) => {
                  return (
                    <Button>
                      <Box
                        onClick={() => {
                          if (item.buttonName === "Cancel") {
                            setOpenModal({ isOpen: false });
                          } else if (item.buttonName === "Add") {
                            handleSaveCity();
                          }
                        }}
                        sx={{
                          padding: "10px 30px",
                          borderRadius: "6px",
                          backgroundColor:
                            item.buttonName === "Cancel"
                              ? "#4c5a6a"
                              : "#17dfba",
                          textTransform: "capitalize",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "white",
                          }}
                        >
                          {item.buttonName}
                        </Typography>
                      </Box>
                    </Button>
                  );
                })}
            </Grid>
          </Box>
        ) : (
          <AlertPopUp
            headText={
              data?.data?.type == "DELETE"
                ? "Are you sure want to delete?"
                : data?.data?.checked
                ? "Are you sure want to approve?"
                : "Are you sure want to un approve?"
            }
            setOpenModal={setOpenModal}
            handleYes={() => {
              if (data?.data?.type == "DELETE") {
                data?.data?.deleteData(data?.data?.deleteId);
                setOpenModal({ isOpen: false });
              } else {
                data.data.handleApprove(data.data.checked, data.data.index);
                setOpenModal({ isOpen: false });
              }
            }}
            warning={data?.data?.type == "DELETE"}
            data={data.data}
          ></AlertPopUp>
        )}
      </Modal>
    </div>
  );

  function handleSaveCity() {
    const isUpdate = data?.data?.isUpdate;
    const isMandatoryFieldsEmpty =
      isEmpty(cityData?.countryId?.id) ||
      isEmpty(cityData?.name) ||
      isEmpty(cityData?.stateId?.id);

    if (isUpdate && isEmpty(data?.data?.id)) {
      isMandatoryFieldsEmpty = true;
    }

    if (isMandatoryFieldsEmpty) {
      alert("All fields are mandatory");
    } else {
      setOpenModal({ isOpen: false });

      const saveCityParams = {
        countryId: cityData.countryId.id,
        name: cityData.name,
        platformIds: [1, 2, 3],
        stateId: cityData.stateId.id,
      };

      if (isUpdate) {
        saveCityParams.locationId = data.data.id;
      }

      data.data.saveCity(saveCityParams);
    }
  }
}
